import React, { createContext } from 'react';

export const fileManagerContext = createContext<{
  scrollContainerRef: React.RefObject<HTMLDivElement>;
} | null>(null);
